import http from "../../services/http";
const path = "api/users";
export const cloneABook = ({ onSuccess, onError, onEnd, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path + "/addselectbook",
        headers: {
          "x-auth-token": store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
